<style scoped>
  /*.article-detail {*/
  /*  position: absolute;*/
  /*  top: 0;*/
  /*  right: 0;*/
  /*  left: 0;*/
  /*  bottom: 0;*/
  /*}*/
  .article-detail {
    background: #F2F2F2;
  }
  .f-article {
    border-bottom:.0625rem solid #e6e6e6;
    margin: 0 0 .375rem 0;
    background: #ffffff;
    padding-left: .9375rem;
    padding-right: .9375rem;
  }
  .text-cut {
    color: #858585;
  }
  .article-wrap {
    font-size: 1rem;
    line-height: 1.6;
  }
  .icon-img {
    width: 1rem;
    height: 1rem;
  }
  .info-wrap {
    font-size: 1rem;
    display: flex;
    padding-bottom: 1.25rem;
    justify-content: space-between;
  }
  .read,.like,.comment {
    margin-top: .4rem;
    padding: .3125rem .625rem .3125rem .3125rem;
  }
  .font-num span {
    color: #adadad;
  }
  .lite-page-tab {
    position: relative;
    font-size: .875rem;
    background: white;
    height: 2.5rem;
    line-height: 2.5rem;
    padding: 0 .75rem;
    box-shadow: 0 .0625rem 0 0 #e6e6e6;
    display: flex;
    align-items: center;
  }
  .lite-page-tab-text{
    color: #222;
    line-height: 1.375rem;
    margin-right: .375rem;
    padding-top: .125rem;
    font-weight: 600;
    font-size: 1rem;
  }
  .card{

    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    background: #FFF;
  }
  .card-wrap {
    margin: 0 1rem;
  }
  .card-main {
    padding-top: .75rem;
    padding-bottom: .75rem;
  }
  .m-box {
    display: flex;
    font-size: 1rem;
  }
  .m-img-box {
    width: 2rem;
    height: 2rem;
    position: relative;
    margin: 0 .5rem 0 0;
  }
  .m-sub-img-box {
    margin: .2rem .5rem 0 0;
  }
  .m-img-box:before {
    content: '';
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /* border: .0625rem solid rgba(0, 0, 0, .05); */
  }
  .m-img-box img {
    width: 100%;
    height: 100%;
  }
  .m-box-col {
    flex: 1;
    width: 100%;
    min-width: 0;
  }
  .m-box-center {
    display: flex;
    justify-content: center;
  }
  .m-box-dir {
    flex-direction: column;
  }
  .m-text-cut {
    color: #565656;
    font-size: .8125rem;
    line-height: 1.5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .m-comment-text-cut {
    color: #BFBFBF;
    font-size: .875rem;
    line-height: 1.5rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .m-text-box>* {
    margin: 0 0 .375rem 0;
  }
  .m-text-box h3 {
    font-size: .9375rem;
    /* line-height: 1.4; */
    line-height: 1.375rem;
    color: #333333;
    word-break: break-word;
    white-space: pre-wrap;
  }
  .cmt-sub-txt {
    line-height: 1.25rem;
    padding: .5rem .625rem;
    background: #f7f7f7;
    color: #333333;
    font-size: .875rem;
    word-wrap: break-word;
  }
  .cmt-sub-txt p {
    margin: 0;
  }
  .cmt-sub-txt .cmt-sub-username {
    color: #6c7880;
    font-size: .875rem;
    word-break: keep-all;
  }
  .cmt-sub-txt span {
    color: #333333;
    font-size: .875rem;
  }
  .cmt-sub-txt .cmt-sub-content {
    word-break: break-all;
  }
  .cmt-sub-txt .total {
    color: #507DAF;
    cursor: pointer;
  }
  .lite-bot {
    margin-top: .5rem;
    line-height: .9375rem;
    font-size: .875rem;
    color: #999;
  }
  .m-box-center-a {
    display: flex;
    align-items: center;
  }
  .lite-bot .time {
    float: left;
  }
  .lite-bot aside {
    float: right;
  }
  .lite-bot aside em {
    margin-left: .1875rem;
    font-style: normal;
  }
  .lite-bot aside+aside {
    margin-right: .875rem;
  }
  .lite-line {
    border-top-width: .0625rem;
    border-right-width: 0;
    border-bottom-width: 0;
    border-left-width: 0;
    border-style: solid;
    border-color: #eee;
    margin: -.75rem -.75rem 0 0;
    padding: .75rem .75rem 0 0;
  }
  .lite-sub-line {
    margin: -.875rem -.875rem 0 0;
    padding: .875rem .875rem 0 0;
  }
  #comment_0 {
    border-top-width: 0;
    border-color: #fff;
  }
  .lite-page-editor {
    /* position: fixed;
    overflow: hidden;
    bottom: 0;
    left: 0;
    right: 0;
    min-height: 2.75rem;
    background: #1C74FF;
    color: #333;
    z-index: 995;
    border-top-width: .0625rem;
    border-right-width: 0;
    border-bottom-width: 0;
    border-left-width: 0;
    border-color: hsla(0,0%,68.6%,.5);
    border-style: solid; */
    transform: translateZ(0);
    -webkit-transform: translateZ(0);
    height: 3.125rem;
    height: calc(3.5rem + constant(safe-area-inset-bottom));
    height: calc(3.5rem + env(safe-area-inset-bottom));
    width: 100%;
    position: fixed;
    bottom: 0;
    background: #ffffff;
    z-index: 995;
    display: flex;
  }
  @media screen and (min-width: 769px) {
    .lite-page-editor {
      width: 750px;
    }
  }
  .lite-page-editor .box-left {
    font-size: 0;
    min-width: 0;
    margin-left: .75rem;
    height: 3.125rem;
    line-height: 3.125rem;
  }
  .lite-page-editor .box-left .main-text {
    font-size: 1rem;
    min-width: 0;
    display: block;
    max-width: 100vw;
  }
  .lite-page-editor .box-left .focus {
    color: #a5adb5;
  }
  .lite-page-editor .box-right {
    margin-right: .75rem;
  }
  .rubberBand {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-name: rubberBand;
    animation-name: rubberBand;
  }
  .refresh-rotate {
    animation: rotate .5s linear infinite;
    -webkit-animation: rotate .5s linear infinite;
  }
  .m-wpop-box {
    background-color: rgba(0, 0, 0, .5);
    top: 0;
    z-index: 10000;
  }
  .m-wpop-box,.m-wpbtn-lbox {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;

  }
  .m-wpbtn-lbox {
    z-index: 10001;
    background: #dee3de;
  }
  .m-wpbtn-list {
    background: #fff;
    display: block;
  }
  .m-wpbtn-list li {
    width: 100%;
    display: block;
    text-align: center;
    border-bottom: .0625rem solid #e5e5e5;
  }
  .m-wpbtn-list li a {
    font-size: 1.125rem;
    color: #333;
    display: inline-block;
    height: 3rem;
    line-height: 3rem;
  }
  .m-wpbtn-list+.m-wpbtn-list {
    margin-top: .3125rem;
  }
  .link-blue {
    color: #1897f2;
    cursor: pointer;
  }
  @keyframes rubberBand {
    from {
      transform: scale3d(1, 1, 1);
    }
    30% {
      transform: scale3d(1.25, 0.75, 1);
    }
    40% {
      transform: scale3d(0.75, 1.25, 1);
    }
    50% {
      transform: scale3d(1.15, 0.85, 1);
    }
    65% {
      transform: scale3d(.95, 1.05, 1);
    }
    75% {
      transform: scale3d(1.05, .95, 1);
    }
    to {
      transform: scale3d(1, 1, 1);
    }
  }
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
      -ms-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
    }
  }
  /* 可以设置不同的进入和离开动画 */
  /* 设置持续时间和动画函数 */
  .slide-fade-enter-active {
    /* transition: all .3s ease; */
    transition: all .3s linear;
  }
  .slide-fade-leave-active {
    /* transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0); */
    transition: all .8s linear;
  }
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */ {
    transform: translateY(.625rem);
    opacity: 0;
  }
  .comment-content {
    padding-bottom: 3.44rem;
    padding-bottom: calc(3.44rem + constant(safe-area-inset-bottom));
    padding-bottom: calc(3.44rem + env(safe-area-inset-bottom));
    background-color: #ffffff;
    position: relative;
    min-height: 15rem;
  }
  .empty {
    position: absolute;
    height: 100%;
    width: 100%;
    /* padding: 6.375rem 0 1.25rem; */
    font-size: .875rem;
    color: #929292;
    text-align: center;
    background: #FFF;
    display: flex;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-bottom: 3.44rem;
    padding-bottom: calc(3.44rem + constant(safe-area-inset-bottom));
    padding-bottom: calc(3.44rem + env(safe-area-inset-bottom));
    padding-top: 2rem;
  }
  .empty-block {
    background: #fbfbfb;
  }
  .no-write-comment-content {
    padding-bottom: 0;
  }
  @media only screen and (device-width:414px) and (device-height:896px) and (-webkit-device-pixel-ratio:3){
    /* .lite-page-editor {
      padding-bottom: env(safe-area-inset-bottom);
    } */
    .comment-content {
      padding-bottom: calc(3.44rem + env(safe-area-inset-bottom));
    }
    .no-write-comment-content {
      padding-bottom: env(safe-area-inset-bottom);
    }
    .m-wpbtn-list:last-child {
      padding-bottom: env(safe-area-inset-bottom);
    }
  }
  @media only screen and (device-width:414px) and (device-height:896px) and (-webkit-device-pixel-ratio:2){
    /* .lite-page-editor {
      padding-bottom: env(safe-area-inset-bottom);
    } */
    .comment-content {
      padding-bottom: calc(3.44rem + env(safe-area-inset-bottom));
    }
    .no-write-comment-content {
      padding-bottom: env(safe-area-inset-bottom);
    }
    .m-wpbtn-list:last-child {
      padding-bottom: env(safe-area-inset-bottom);
    }
  }
  @media only screen and (device-width:375px) and (device-height:812px) and (-webkit-device-pixel-ratio:2){
    /* .lite-page-editor {
      padding-bottom: env(safe-area-inset-bottom);
    } */
    .comment-content {
      padding-bottom: calc(3.44rem + env(safe-area-inset-bottom));
    }
    .no-write-comment-content {
      padding-bottom: env(safe-area-inset-bottom);
    }
    .m-wpbtn-list:last-child {
      padding-bottom: env(safe-area-inset-bottom);
    }
  }
  @media only screen and (device-width:375px) and (device-height:812px) and (-webkit-device-pixel-ratio:3){
    /* .lite-page-editor {
      padding-bottom: env(safe-area-inset-bottom);
    } */
    .comment-content {
      padding-bottom: calc(3.44rem + env(safe-area-inset-bottom));
    }
    .no-write-comment-content {
      padding-bottom: env(safe-area-inset-bottom);
    }
    .m-wpbtn-list:last-child {
      padding-bottom: env(safe-area-inset-bottom);
    }
  }
  .m-sub-box {
    display: flex;
    font-size: 1rem;
    padding: .75rem;
  }
  .cmt-sub-sub-txt {
    line-height: 1.25rem;
    padding: 0 .625rem .5rem 0;
    background: #f7f7f7;
    color: #333333;
    font-size: .875rem;
    word-wrap: break-word;
  }
  .cmt-sub-sub-txt p {
    margin: 0;
  }
  .cmt-sub-sub-txt .cmt-sub-username {
    color: #6c7880;
    font-size: .8125rem;
    word-break: keep-all;
  }
  .cmt-sub-sub-txt span {
    color: #333333;
    font-size: .875rem;
  }
  .cmt-sub-sub-txt .cmt-sub-content {
    word-break: break-all;
    font-size: .9375rem;
  }
  .cmt-sub-sub-txt .total {
    color: #507DAF;
    cursor: pointer;
  }
  .lite-sub-bot {
    line-height: .9375rem;
    font-size: .875rem;
    color: #ababab;
  }
  .lite-sub-bot .time {
    float: left;
    font-size: .8125rem;
    text-indent: .125em;
  }
  .lite-sub-bot aside {
    float: right;
  }
  .lite-sub-bot aside em {
    margin-left: .1875rem;
    font-style: normal;
  }
  .lite-sub-bot aside+aside {
    margin-right: .875rem;
  }
  .m-notice-icon-wrap {
    display: inline-block;
    position: relative;
  }
  .m-notice-icon-number {
    width: auto;
    height: .75rem;
    line-height: .75rem;
    font-size: .75rem;
    color:#fff;
    text-align: center;
    background-color: #f00;
    border-radius: .375rem;
    position: absolute;
    right: 0.1875rem;
    top: -.5rem;
    padding: 0 .375rem;
    display: flex;

  }
  .number-dot{
    -webkit-transform: scale(0.8);
    -moz-transform: scale(0.8);
    -o-transform: scale(0.8);
    transform: scale(0.8);
    margin:auto;
  }
  .m-notice-number {
    min-width: 1rem;
    height: 1rem;
    padding: 0 .1875rem;
    border-radius: .5rem;
    line-height: 1rem;
    text-align: center;
    color: #FA5A57;
    position: absolute;
    top: -.4375rem;
    right: -.625rem;
    font-size: 12px;
    font-weight: 600;
    background-color: #fff;
  }
  .shield-box{
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #FFF;
  }
  .shield-box-img{
    margin: auto;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .shield-text{
    text-align: center;
    color: gray;
  }
  .number-animate {
    animation: addOne .5s linear;
  }
  @keyframes addOne {
    from { top: -0.5rem; opacity: 1; }
    to {top: -3.5rem; opacity: 0;}
  }
</style>

<template>
  <div class="article-detail m-container-max">

    <lite-app-header v-if="isMideaConnect && !useDefaultHeader" :title="articleDetail.sName || articleDetail.title"
    :showRight="showRight"
    @shareAction="shareAction"
    ></lite-app-header>

    <!-- 底部栏 -->
    <div v-show="(!is_shield)&&isMideaConnect" class="lite-page-editor" :style="{left: bottomLeft}">
    <!--<div class="lite-page-editor" :style="{left: bottomLeft}">-->
      <div class="m-box" style="display: flex;justify-content: center;align-items: center;height: 2.75rem;flex: 1;margin: auto;"
      @click="writeComment('1', articleDetail.materialId)">
        <div class="box-right m-box-col m-box-center-a" style="justify-content: center;margin-top: .5rem;">
          <div class="m-notice-icon-wrap" @click.stop="thinkGood(articleDetail, 'article')">
            <img src="../assets/images/c-good-blue.png" v-if="articleDetail.hasClicked" style="width: 1.5rem; height: 1.5rem;margin: 0 1rem;" alt=""/>
            <img src="../assets/images/c-good-gray.png" v-else style="width: 1.5rem; height: 1.5rem;margin: 0 1rem;" alt=""/>
            <div class="m-notice-number" :style="{'right': relativeRight(articleDetail.likedNum)}" v-if="!(articleDetail.likedNum === 0 || typeof articleDetail.likedNum === 'undefined')">{{articleDetail.likedNum}}</div>
            <div :class="{'number-animate': goodAnimate}" style="background: transparent;position:absolute;top: 0;" :style="{'right': relativeRight(articleDetail.likedNum), 'display': goodAnimate ? 'block' : 'none'}">
              <span style="font-size: 1rem;color: red;">{{animateNumber}}</span>
            </div>
          </div>
          <div class="m-notice-icon-wrap" @click.stop="favorite(articleDetail, 'article')">
            <img src="../assets/images/c-favorite-blue.png"
            v-if="articleDetail.hasFavorite" style="width: 1.5rem; height: 1.5rem;margin: 0 1rem;" alt=""/>
            <img src="../assets/images/c-favorite-gray.png"
            v-else style="width: 1.5rem; height: 1.5rem;margin: 0 1rem;" alt=""/>
            <div class="m-notice-number" :style="{'right': relativeRight(articleDetail.favoriteNum)}" v-if="!(articleDetail.favoriteNum === 0 || typeof articleDetail.favoriteNum === 'undefined')">{{articleDetail.favoriteNum}}</div>
            <div :class="{'number-animate': favoriteAnimate}" style="background: transparent;position:absolute;top: 0;" :style="{'right': relativeRight(articleDetail.favoriteNum), 'display': favoriteAnimate ? 'block' : 'none'}">
              <span style="font-size: 1rem;color: red;">{{animateNumber}}</span>
            </div>
          </div>
          <div class="m-notice-icon-wrap" @click.stop="scorllComment()">
            <img src="../assets/images/c-comment-gray.png"
            style="width: 1.5rem; height: 1.5rem;margin: 0 1rem;" alt=""/>
            <div class="m-notice-number" :style="{'right': relativeRight(articleDetail.commentNum)}" v-if="!(articleDetail.commentNum === 0 || typeof articleDetail.commentNum === 'undefined')">{{articleDetail.commentNum}}</div>
          </div>
        </div>
        <div class="box-left m-box-col m-box-center-a"
        @click="writeComment('1', articleDetail.materialId)">
          <div style="background-color: #f5f5f5;width: 90%;border-radius: 1rem;height: 2rem;padding:.25rem 0 .25rem 1rem;">
            <span class="m-box-center-a main-text m-comment-text-cut focus"
            style="font-size: .875rem;" @click="showModal">{{$t('lang.contentWriteAComment')}}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 资讯数据 -->
    <div v-show="!is_shield" class="main" :style="(isMideaConnect&&!useDefaultHeader)?'margin-top: 3rem;':''">
      <div class="card" :style="isMideaConnect?'height: calc(100vh - 100px);':'height:100vh;'">
        <ContentTemplate :article-detail="articleDetail" @good="myThinkGood"></ContentTemplate>
        <div
        @touchmove="loadComment()"
        @mousewheel="loadComment()"
        class="pdt27"
        ref="ref_lite_page_tab">
          <div class="lite-page-tab" >
            <span class="lite-page-tab-text">{{$t('lang.contentComment')}} ({{articleDetail.commentNum}})</span>
            <img src="../assets/images/refresh.png" alt="" style="width: 1.25rem;height: 1.25rem;"
            @click="refresh()"
            :class="{'refresh-rotate': isRefresh}">
          </div>
          <div class="comment-content" :class="{'empty-block': appCommentList.length === 0, 'no-write-comment-content': !isMideaConnect}">
            <div style="background: #ffffff;" v-for="(item, index) in appCommentList" :key="'info2-'+item.id+index">
              <div class="card-avatar-box">
                <div class="card-wrap">
                  <div class="card-main">
                    <div class="m-box">
                      <div class="m-img-box">
                        <img src="../assets/images/c-photo_default_icon.png" alt=""
                        v-if="item.hideName === 1">
                        <img v-else :src="commentHeadImgUrl+item.createUserAccount"
                        :onerror="defaultHead" alt=""
                        style="border-radius: 50%;" >
                      </div>
                      <div class="m-box-right m-box-col m-box-center m-box-dir" :ref="'comment_'+item.id" :id="'comment_'+index">
                        <div class="m-box">
                          <div class="m-box-dir m-box-col">
                            <div class="m-text-box" @click="transShow(item.id)">
                              <h4 class="m-text-cut">{{item.createUsername}}</h4>
                              <div v-if="!item.contentTooLong">
                                <h3>{{(item.state == -2)?$t('lang.contentCommentDeleted'):item.content}}
                                  <a class="link-blue"
                                    v-show="item.content&&(item.content.length > 92)&&(item.state != -2)"
                                    href="javascript:void(0);"
                                    style="float: right;padding-right: .5rem;"
                                    @click.stop="contentTooLong(item,'comment')">{{$t('lang.hide')}}</a>
                                </h3>
                              </div>
                              <div v-else>
                                <h3>{{item.content&&item.content.substring(0, 92) + '...'}}<a class="link-blue"
                                href="javascript:void(0);" style="float: right;padding-right: .5rem;"
                                @click.stop="contentTooLong(item,'comment')">{{$t('lang.all')}}</a></h3>
                              </div>
                              <div style="clear: both;"></div>
                            </div>
                            <div class="lite-bot m-text-cut">
                              <div class="m-box-center-a time"
                                style="font-size: .8125rem;">{{item.createTime | showWeekday}}</div>
                              <aside @click="thinkGood(item, 'comment')">
                                <img src="../assets/images/c-good-blue.png" v-if="item.hasClicked"
                                style="width: 1rem;height: 1rem;margin-right: .25rem;" alt=""
                                class="rubberBand">
                                <img src="../assets/images/c-good-black.png" v-else
                                style="width: 1rem;height: 1rem;margin-right: .25rem;" alt="">
                                <em>{{item.likedNum || 0}}</em>
                              </aside>
                              <aside @click="writeComment('2', item.id)">
                                <img src="../assets/images/c-comment-black.png"
                                style="width: 1rem;height: 1rem;margin-top: .125rem;" alt="">
                                <em></em>
                              </aside>
                            </div>
                            <!-- 二级评论 -->
                            <div v-if="item.subReplayList && item.subReplayList.length > 0" style="margin-top: .875rem;">
                              <div class="m-box" v-for="(comment,index) in item.subReplayList" :key="comment.id" style="margin-bottom: .875rem;">
                                <div class="m-img-box">
                                  <img src="../assets/images/c-photo_default_icon.png" alt="" v-if="comment.hideName === 1">
                                  <img :src="commentHeadImgUrl+comment.createUserAccount"
                                  :onerror="defaultHead" alt=""
                                  style="border-radius: 50%;" v-else>
                                </div>
                                <div class="m-box-right m-box-col m-box-center m-box-dir" :ref="'comments_'+comment.id"
                                :id="'comments_'+index">
                                  <div class="m-box">
                                    <div class="m-box-dir m-box-col">
                                      <div class="m-text-box" @click="transShow(item.id)">
                                        <h4 class="m-text-cut">{{comment.createUsername}}</h4>
                                        <div v-if="!comment.contentTooLong">
                                          <h3>{{(comment.state == -2)?$t('lang.contentCommentDeleted'):comment.content}}
                                            <a class="link-blue" v-show="comment.content&&(comment.content.length > 72)&&(comment.state != -2)"
                                            href="javascript:void(0);" style="float: right;padding-right: .5rem;"
                                            @click.stop="contentTooLong(comment,'comments')">{{$t('lang.hide')}}</a></h3>
                                        </div>
                                        <div v-else>
                                          <h3>{{comment.content.substring(0, 72) + '...'}}
                                          <a class="link-blue"
                                          href="javascript:void(0);" style="float: right;padding-right: .5rem;"
                                          @click.stop="contentTooLong(comment,'comments')">{{$t('lang.all')}}</a></h3>
                                        </div>
                                        <div style="clear: both;"></div>
                                      </div>
                                      <div class="lite-bot m-text-cut">
                                        <div class="m-box-center-a time"
                                        style="font-size: .8125rem;">{{comment.createTime | showWeekday}}</div>
                                        <aside @click="thinkGood(comment, 'comment')">
                                          <img src="../assets/images/c-good-blue.png" v-if="comment.hasClicked"
                                          style="width: 1rem;height: 1rem;margin-right: .25rem;" alt="" class="rubberBand">
                                          <img src="../assets/images/c-good-black.png" v-else
                                          style="width:1rem;height: 1rem;margin-right: .25rem;" alt="">
                                          <em>{{comment.likedNum || 0}}</em>
                                        </aside>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="empty" v-if="appCommentList.length === 0">
                 <img :src="noData" style="width: 180px;height: 140px;margin: auto auto 5px auto;" />
                  {{$t('lang.writeAComment')}}
            </div>
            <p v-if="appCommentList.length > 0"
              style="font-size: .875rem;text-align: center;color: gray;padding-top: .875rem;border-top: 1px solid #eee;">
              {{$t('lang.contentNoMoreComment')}}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- 获取不到资讯时 -->
    <div v-if="is_shield" class="shield-box">
      <div class="shield-box-img" >
        <img :src="noData"  alt="" />
        <p class="shield-text" >{{err_msg}}</p>
      </div>
    </div>

    <!-- 评论弹窗 -->
    <div class="m-wpop-box "
    v-if="show"
    @click="transShowClose">
      <div @click.stop>
        <content-comment
          style="z-index: 10005;"
          :show="show"
          :comment-params="commentParams"
          :pageNum.sync="pageNum"
          :comment-type="articleDetail.commentType"
          @close="commentClose"
          @success="commentNumAdd"></content-comment>
      </div>
    </div>

    <div style="position: fixed;
    top: 0;left: 0;
    bottom: 0;right: 0;
    background-color: rgba(0,0,0,.5);
    z-index: 10002;"
    v-if="errorStatus"></div>

  </div>
</template>

<script>
import ContentTemplate from '../components/ContentTemplate'
import ContentComment from '../components/ContentComment'
import { articleMixin } from '../mixins/article'
import Vue from 'vue'
import LiteAppHeader from '../components/LiteAppHeader'
import { isPC, Throttle, isMideaConnect, getCookie, getUUID } from '../utils/utils'
import { handleContentDetailResponse } from './handleNMCReponse'
import dataRanger from '../service/data-rangers/index'
import noData from '@/assets/images/no-data.png'
import platform from '../platform'

const PROJECT_CONFIG = require('../../config')
export default {
  components: {
    ContentTemplate,
    ContentComment,
    LiteAppHeader
  },
  data () {
    return {
      articleDetail: { title: '', createDataTime: '', author: '' },
      isPC: isPC(),
      success: null,
      bottomLeft: '',
      appCommentList: [],
      isRefresh: false,
      show: false,
      loadingMoreStatus: 0, // 0 未开始 1 正在加载 2 已结束
      pageNum: 1,
      commentId: '',
      hasLoadComment: false,
      showPopup: false,
      commentParams: {},
      headImgUrl: '',
      defaultHead: 'this.src="' + require('../assets/images/photo_default.png') + '"',
      targetId: '',
      noData: noData,
      is_shield: false, // 是否屏蔽了资讯
      err_msg: '',
      materialId: '',
      commentNum: 0,
      showRight: false, // 是否展示右边分享标识
      goodAnimate: false,
      favoriteAnimate: false,
      animateNumber: '+1',
      createdStatus: false
    }
  },
  mixins: [articleMixin],
  computed: {
    isMideaConnect () {
      // return true
      return isMideaConnect()
    },
    useDefaultHeader () {
      return this.$route.query.defaultHeader && this.$route.query.defaultHeader === '1'
    },
    isMission() {
      return window.navigator.userAgent.toLocaleUpperCase().indexOf('MIDEACONNECT') > -1
    },
  },
  methods: {
    documentVisible() {
      if (document.visibilityState === 'visible') {
        platform.hideNav()
      }
    },
    commentNumAdd () {
      this.articleDetail.commentNum++
    },
    relativeRight (num) {
      if (typeof num !== 'number') num = 0
      return (-(String(num).length - 1) * 0.375 + 0.25) + 'rem'
    },
    myThinkGood (val) {
      this.thinkGood(val.item, val.typeStr)
    },
    transShow (clickId) {
      if (!this.isMideaConnect) {
        return
      }
      if (!this.isMideaConnect) {
        return
      }
      this.commentParams = { targetId: clickId, targetType: '2', type: this.$route.query.type || '' }
      this.show = true
    },
    transShowClose () {
      this.show = false
    },
    async refresh () {
      this.isRefresh = true
      const identification = this.$route.query.identification
      if (this.materialId) {
        const response = await this.getCommentDetail(this.materialId)
        this.handleCommentData(response)
        const res = await this.$store.dispatch('getContentDetail', {
          id: this.articleId,
          type: this.$route.query.type,
          locale: this.$route.query.locale,
          ssoToken: identification === 'admin' && this.$route.query.token,
          identification: identification,
          appKey: this.$route.query.appKey
        })
        console.log(res)
        if (res.data.code === 0) {
          console.log('!!!!!!', res.data.data.commentnum)
          this.articleDetail.commentNum = res.data.data.commentnum
          setTimeout(() => {
            this.isRefresh = false
          }, 1500)
          
        }
      }
    },
    displaySubReply (e, comment) {
      if (comment[3].hidden) {
        e.target.innerHTML = this.$t('lang.hidden')
      } else {
        e.target.innerHTML = `${this.$t('lang.seeAll')}${comment.length}${this.$t('lang.replies')}`
      }
      for (let i = 3; i < comment.length; i++) {
        comment[i].hidden = !comment[i].hidden
      }
    },
    writeComment (targetType, id = null) {
      if (!this.isMideaConnect) {
        return
      }
      if (!this.isMideaConnect) {
        return
      }
      if (id === null) {
        if (targetType === '1') {
          id = this.articleId
        } else {
          id = this.commentId
        }
      }
      this.hasLoadComment = false
      this.commentParams = { targetId: id, targetType: targetType, articleId: this.articleId }
      this.show = true
    },
    // 发布评论后关闭以及刷新
    commentClose () {
      this.show = false
      this.refresh()
    },
    // 定位到评论
    scorllComment () {
      this.$refs.ref_lite_page_tab.scrollIntoView()
    },
    // 文字过多时的：收起、展开
    contentTooLong (item, type) {
      item.contentTooLong = !item.contentTooLong
      if (item.contentTooLong && this.$refs[`${type}_${item.id}`]) {
        const dom = this.$refs[`${type}_${item.id}`][0]
        if (dom) {
          const topNum = dom.getBoundingClientRect().top;
          (topNum < 0) && this.$refs[`${type}_${item.id}`][0].scrollIntoView()
        }
      }
    },
    thinkGood (item, typeStr) {
      console.log(item)
      if (!this.isMideaConnect) {
        return
      }
      let id = ''
      if (typeStr === 'comment') {
        id = item.id
      } else {
        id = item.materialId
      }
      const identification = this.$route.query.identification
      if (!item.hasClicked) {
        // 点赞
        dataRanger.send('user_interaction', {
          operation_type: typeStr === 'article' ? '页面点赞' : '评论点赞',
          content_id: item.materialId,
          author_id: sessionStorage.getItem('username')
        })
        console.log('!!! 点赞的传参', {
          materialId: id,
          targetType: typeStr,
          ssoToken: identification === 'admin' && this.$route.query.token,
          identification: identification,
          appKey: this.$route.query.appKey
        })
        console.log('!!! 点赞的其他-0--', this.$route)
        this.$store.dispatch('contentLikeAdd', {
          materialId: id,
          targetType: typeStr,
          ssoToken: identification === 'admin' && this.$route.query.token,
          identification: identification,
          appKey: this.$route.query.appKey
        })
          .then(success => {
            if (success && success.data && success.data.code === 0) {
              item.hasClicked = true
              item.likedNum = item.likedNum + 1
              this.animateNumber = '+1'
              if (typeStr === 'article') {
                this.goodAnimate = true
                setTimeout(() => {
                  this.goodAnimate = false
                }, 500)
              }
            } else {
              if (success.data.code === -1) {
                this.$toastMessage({ icon: '&#xe7a3;', message1: success.data.msg })
                // success.data.msg
              }
              // _self.success = false;
              // _self.popTxt = success.data.msg;
              // _self.showMask = true;
              // setTimeout(function() {
              //   _self.showMask = false;
              // }, 3000);
            }
          })
      } else {
        // 取消点赞
        dataRanger.send('user_interaction', {
          operation_type: typeStr === 'article' ? '取消页面点赞' : '评论取消点赞',
          content_id: item.materialId,
          author_id: sessionStorage.getItem('username')
        })
        this.$store.dispatch('contentLikeCancel', {
          materialId: id,
          targetType: typeStr,
          ssoToken: identification === 'admin' && this.$route.query.token,
          identification: identification,
          appKey: this.$route.query.appKey
        })
          .then(success => {
            if (success && success.data && success.data.code === 0) {
              item.hasClicked = false
              if (item.likedNum > 0) {
                item.likedNum = item.likedNum - 1
                if (typeStr === 'article') {
                  this.animateNumber = '-1'
                  this.goodAnimate = true
                  setTimeout(() => {
                    this.goodAnimate = false
                  }, 500)
                }
              }
            } else {
            // _self.success = false;
            // _self.popTxt = success.data.msg;
            // _self.showMask = true;
            // setTimeout(function() {
            //   _self.showMask = false;
            // }, 3000);
            }
          })
      }
    },
    favorite (item, typeStr) {
      const identification = this.$route.query.identification
      if (!item.hasFavorite) {
        // 点赞
        dataRanger.send('page_view', {
          operation_type: '页面收藏',
          content_id: item.materialId,
          author_id: sessionStorage.getItem('username')
        })
        this.$store.dispatch('contentFavoriteAdd',
          {
            materialId: item.materialId,
            targetType: typeStr,
            ssoToken: identification === 'admin' && this.$route.query.token,
            identification: identification,
            appKey: this.$route.query.appKey
          }).then(success => {
          if (success && success.data && success.data.code === 0) {
            item.hasFavorite = true
            item.favoriteNum = item.favoriteNum + 1
            this.animateNumber = '+1'
            this.favoriteAnimate = true
            setTimeout(() => {
              this.favoriteAnimate = false
            }, 500)
          } else {
            if (success.data.code === -1) {
              this.$toastMessage({ icon: '&#xe7a3;', message1: success.data.msg })
              // success.data.msg
            }
            // _self.success = false;
            // _self.popTxt = success.data.msg;
            // _self.showMask = true;
            // setTimeout(function() {
            //   _self.showMask = false;
            // }, 3000);
          }
        })
      } else {
        // 取消点赞
        dataRanger.send('page_view', {
          operation_type: '取消页面收藏',
          content_id: item.materialId,
          author_id: sessionStorage.getItem('username')
        })
        this.$store.dispatch('contentFavoriteCancel',
          {
            materialId: item.materialId,
            targetType: typeStr,
            ssoToken: identification === 'admin' && this.$route.query.token,
            identification: identification,
            appKey: this.$route.query.appKey
          })
          .then(success => {
            if (success && success.data && success.data.code === 0) {
              item.hasFavorite = false
              if (item.favoriteNum > 0) {
                item.favoriteNum = item.favoriteNum - 1
                this.animateNumber = '-1'
                this.favoriteAnimate = true
                setTimeout(() => {
                  this.favoriteAnimate = false
                }, 500)
              }
            } else {
              // _self.success = false;
              // _self.popTxt = success.data.msg;
              // _self.showMask = true;
              // setTimeout(function() {
              //   _self.showMask = false;
              // }, 3000);
            }
          })
      }
    },
    getLikedAndFavoritedNum (targetId) {
      const identification = this.$route.query.identification
      return this.$store.dispatch('checkContentHasClicked', {
        target_id: targetId,
        targetType: 1,
        sourceType: 1,
        ssoToken: identification === 'admin' && this.$route.query.token,
        identification: identification,
        appKey: this.$route.query.appKey
      }).then(res => {
        return res
      })
    },
    getRichText (res) {
      return this.$store.dispatch('getRichText', { contentUrl: res.data.data.contentUrl }).then(content => {
        return content
      })
    },
    // 调已读接口
    setContentReadAdd (data) {
      const identification = this.$route.query.identification
      this.$store.dispatch('contentReadAdd',
        {
          materialId: data.materialId,
          ssoToken: identification === 'admin' && this.$route.query.token,
          identification: identification,
          appKey: this.$route.query.appKey
        }).then(readRes => {
        console.log(readRes)
        // if (readRes && (readRes.data.code !== 0)) {
        //   this.$toastMessage({ icon: '&#xe69f;', message1: `调用已读接口失败，原因:${readRes.data.msg}` })
        // }
      })
    },
    // 新的已读接口
    newContentReadAdd (data) {
      const identification = this.$route.query.identification
      console.log('!!!!!!! 已读接口参数----------', {
        materialId: data.materialId,
        ssoToken: identification === 'admin' && this.$route.query.token,
        identification: identification,
        isThirdPartPlat: identification === 'admin' ? this.$route.query.isThirdPartPlat : !isMideaConnect(),
        appKey: this.$route.query.appKey
      })
      this.$store.dispatch('addReadedMxpOther',
        {
          materialId: data.materialId,
          ssoToken: identification === 'admin' && this.$route.query.token,
          identification: identification,
          isThirdPartPlat: identification === 'admin' ? this.$route.query.isThirdPartPlat : !isMideaConnect(),
          appKey: this.$route.query.appKey
        }).then(readRes => {
        console.log('已读接口返回内容0-------', readRes)
        // if (readRes && (readRes.data.code !== 0)) {
        //   this.$toastMessage({ icon: '&#xe69f;', message1: `调用已读接口失败，原因:${readRes.data.msg}` })
        // }
      })
    },
    getContentDetail () {
      // type: 2 -- id是素材id，其他值表示id是投稿id
      const identification = this.$route.query.identification
      this.$store.dispatch('getContentDetail',
        {
          id: this.articleId,
          ssoToken: identification === 'admin' && this.$route.query.token,
          type: this.$route.query.type,
          locale: this.$route.query.locale,
          identification: identification,
          appKey: this.$route.query.appKey
        }).then(res => {
        console.log('contentDetail----', res)
        if (res && res.data.code === 0) {
          if (res.data.data) {
            this.showRight = (res.data.data?.shareRange > 0)
          }

          if (res.data.data.msgType === 2) {
            this.isMideaConnect = true
            // const data = handleContentDetailResponse(res.data, null)
            // this.handleArticleData(data)
          } else {
            let reqArr = [this.getRichText(res)]
            if (this.isMideaConnect) {
              reqArr = reqArr.concat([this.getLikedAndFavoritedNum(res.data.data.materialId)])
            }
            Promise.all(reqArr).then(response => {
              res.data.data.content = response[0].data
              console.log('response', response)
              const data = handleContentDetailResponse(res.data, (response?.[1] ? response[1].data : null))
              this.materialId = res.data.data.materialId

              this.getCommentDetail(res.data.data.materialId).then(res => {
                this.handleCommentData(res)
              })
              // console.log('this.handleArticleData(data)', this.handleArticleData)
              // console.log('this.handleArticleData(data)', this.handleArticleData(data))
              console.log('!!!!!!!! handleArticleData---', this.handleArticleData)
              this.handleArticleData(data)
              console.log('!!!!!!!! this.$route.path---', this.$route.path)
              if (this.$route.path === '/error') return
              this.newContentReadAdd(res.data.data)
              this.weixinShare()
              
              // (this.isMideaConnect) && this.setContentReadAdd(res.data.data)
            }).catch(err => {
              /* eslint-disable */
              if (String(err).indexOf(`'likeClickByUser' of null`) > -1) {
                console.log('核对是否点赞或收藏接口出错，原因可能是token过期或失效')
              }
              /* eslint-enable */
              console.log('878', err)
            })
          }
        } else {
          this.$store.dispatch('setShowLoadingPic', {
            showLoadingPic: false
          })

          this.is_shield = true
          this.err_msg = res.data.msg
          if (res.data.code !== 81012 && res.data.code !== 81013) {
            this.$toastMessage({ icon: '&#xe69f;', message1: res.data.msg })
          }
        }
      }).catch(err => {
        /* eslint-disable */
          if (String(err).indexOf(`'contentUrl' of null`) > -1) {
            this.$toastMessage({ icon: '&#xe69f;', message1: `${this.$t('lang.contentAddressNotFound')}` })
          } else {
            // window.alert(err)
            console.log(err)
          }
          /* eslint-enable */
      })
    },
    getCommentDetail (target_id, pageNum = 1) {
      const identification = this.$route.query.identification
      return this.$store.dispatch('getContentQueryCommentList', {
        target_id: target_id,
        pageNum: pageNum,
        pageSize: '10',
        targetType: 1,
        ssoToken: this.$route.query.token,
        isThirdPartPlat: identification === 'admin' ? JSON.parse(this.$route.query.isThirdPartPlat) : !this.isMideaConnect,
        identification: identification,
        appKey: this.$route.query.appKey
      })
    },
    handleCommentData (data) {

      if (data && data.data && data.data.code === 0) {

        this.commentNum = data.data.data.total

        this.$store.dispatch('setCommentNum', {
          commentNum: this.commentNum
        })

        if (data.data.data && data.data.data.list && data.data.data.list.length) {

          data.data.data.list.forEach((item) => {
            if (item.content) {
              item.content = item.content.replace(/%26/g, '&')
            }
          })
          data.data.data.list.forEach(item => {
            item.contentTooLong = item.content?(item.content.length > 92):false
            if (item.subReplayList.length > 0) {
              item.subReplayList.forEach((ite, index) => {
                ite.contentTooLong = ite.content?(ite.content.length > 72):false
                ite.hidden = (index >= 3)
              })
            }
          })
          if (this.isRefresh) {
            this.appCommentList = []
          }
          if (this.pageNum === 1) {

            this.appCommentList = data.data.data.list
          } else {

            this.appCommentList = this.appCommentList.concat(data.data.data.list)
          }

          this.$forceUpdate()

        }
      }

      if (this.isRefresh) {

        this.isRefresh = false
      }

    },
    validateParams () {
      this.articleId = this.$route.query.id
      return !(typeof this.$route.query.id === 'undefined')
    },
    hideBox () {
      document.addEventListener('click', (e) => {
        // 如果当前点击的这个对象是这个模态框的话
        if((e.target).closest('.m-wpop-box')) {
          //  那么这个模态框还是显示的
          this.show = true
        } else if(!(e.target).closest('.content-comment')) {
          // 如果当前点击的这个对象是这个show按钮以外的对象，那么这个模态框就隐藏
          this.show = false
        }
      })
    },
    showModal () {
      this.show = true
    },
    loadComment () {
      this.loadMoreComment()
    },
    loadMoreComment: Throttle(function () {
      if (Math.ceil(this.$store.getters.commentNumber / 10) > this.pageNum) {
        ++this.pageNum
        this.getCommentDetail(this.materialId,this.pageNum).then(res => {
          this.handleCommentData(res)
        })
      }
    }),

    //分享操作
    async shareAction(){

      /**
        * title           分享标题
        * subTitle         分享子标题
        * action           openH5 或 openUrl
        * widgetId         H5模块id
        * widgetExtra     扩展参数
        * url             url地址
        * imageUrl         图片地址
        * actionType       1-分享 2-红包 3-网盘 4-红包通知 5-分享图片 6-分享小程序(目前只有项目分支支持)
        * shareRange       0-美信和其它都不分享 1-只分享到美信 2-分享到美信和其它 3-分享其他,不分享美信,(项目分支包涵qq空间，美的分支没有) 4-分享其他和美信，不显示第二列 5-分享微信和微信朋友圈 6-只显示分享到微信朋友
        * sharePageTitle   服务号希望ActionBar 一直显示服务号名称
        * sid             服务号id
        **/

      console.log(PROJECT_CONFIG)
      console.log(this.articleId)
      console.log(this.$i18n.locale)
      let url = `${ PROJECT_CONFIG.baseUrl }/newservicenopages/#/content/detail?id=${ this.articleId }`
      if (this.$route.query.type) {
        url = url + `&type=${this.$route.query.type}`
      }
      if (this.$route.query.locale) {
        url = url + `&locale=${this.$route.query.locale}`
      }
      var shareObj = {
        title: this.articleDetail.title,
        subTitle: this.articleDetail.description,
        action: 'openUrl',
        widgetId: '',
        widgetExtra: '',
        imageUrl: this.articleDetail.coverImg,
        actionType: 1,
        shareRange: this.articleDetail.shareRange,
        url:url,
        sharePageTitle:'',
        sid: ''
      }
      if (window.cordova) {
        window.cordova.exec(function () {
        }, function () {
        }, 'MideaCommon', 'showShare', [shareObj])
      }
    },
    // 埋点设置个人信息
    setTracking () {
      let uid = ''
      if (this.isMideaConnect) {
        uid = getCookie('username')
      } else {
        uid = getUUID(32, 16)
      }
      window.collectEvent('config', {
        user_unique_id: uid
      })
      const from = this.$route.query.from
      let reffer_name = ''
      switch (from) {
      case 'official':
        reffer_name = '从公众号入口进入'
        break
      case 'up':
        reffer_name = '从UP主详情入口进入'
        break
      case 'my':
        reffer_name = '从个人中心入口进入'
        break
      case 'discount':
        reffer_name = '从员工优惠入口进入'
        break
      default:
        reffer_name = '从外链入口进入'
      }
      dataRanger.send('page_view', {
        page_name: '公众号详情页',
        page_path: this.$route.path,
        page_type: '文章详情页',
        reffer_name: reffer_name
      })
    },
    weixinShare () {
      const self = this
      if (window.isWxTagLaunch) {
        window.wx.ready(function () {
          window.wx.onMenuShareAppMessage({
            title: self.articleDetail.title,
            link: window.location.href,
            imgUrl: self.articleDetail.coverImg,
            desc: self.articleDetail.summary,
            success: function () {
              console.log('share app message success!!!')
            }
          })
          window.wx.onMenuShareTimeline({
            title: self.articleDetail.title,
            link: window.location.href,
            imgUrl: self.articleDetail.coverImg,
            success: function () {
              console.log('share timeline success!!!')
            }
          })
        })
      }
    }
  },
  beforeCreate () {
    console.log('钩子函数beforeCreate')
  },
  created () {
    console.log('钩子函数created')
    this.$watch('$route.query', (newQuery) => {
      // 获取参数值
      const paramValue = newQuery.paramName
      // 执行相应的操作
      console.log(`参数值发生变化，新值为：${paramValue}`)
      location.reload()
    })
    if (this.createdStatus === false) this.createdStatus = true
    this.setTracking()
    this.commentHeadImgUrl = this.$store.getters.headImgUrl
    if (this.validateParams()) {
      const result = {
        data: {
          /* global CONFIG */
          baseUrl: CONFIG.baseUrl
        }
      }
      Vue.prototype.$baseUrl = result.data.baseUrl
      this.getContentDetail()
    }
    console.log('isMission', this.isMission)
    if (this.isMission) {
      document.addEventListener('visibilitychange', this.documentVisible)
    }
  },
  beforeMount () {
    console.log('钩子函数beforeMount')
  },
  mounted () {
    console.log('钩子函数mounted')
    /* eslint-disable */
    $('#app').css('overflow-x', 'hidden')
    /* eslint-enable */
    // this.hideBox()
  },
  beforeUpdate () {
    console.log('钩子函数beforeUpdate')
  },
  updated () {
    console.log('钩子函数updated')
  },
  beforeDestroy () {
    console.log('钩子函数beforeDestroy')
    dataRanger.send('leave_page', {
      page_name: '文章详情页',
      page_path: this.$route.path
    })
    document.removeEventListener('visibilitychange', this.documentVisible)
  },
  destroyed () {
    console.log('钩子函数destroyed')
  },
  activated () {
    console.log('钩子函数activated')
    if (this.createdStatus === true) {
      this.createdStatus = ''
    } else {
      const meta = document.getElementsByTagName('meta')
      for (let i = 0; i < meta.length; i++) {
        if (meta[i].id === 'shareRange') {
          if (meta[i].content == '0' || meta[i].content == '1') {
            this.$router.replace({
              path: '/error',
              query: {
                redirectedUrl: encodeURIComponent(window.location.href)
              }
            })
            return
          }
          break
        }
      }
    }
  },
  deactivated () {
    console.log('钩子函数deactivated')
  }
}
</script>
